import React, {FC, ReactElement, useEffect, useState} from 'react';
import Set from '../../set/Set';
import './VTimeline.scss';
import styled from 'styled-components';

type vTimelineProps = {
    index: number | null,
    path: {
        slideIndex: number,
        comboIndex: number,
        setIndex: number | null,
        groupIndex: number | null,
        elementIndex: number | null,
    } | null,
    name: string,
    editorPlugins: any | null,
    settings: {
        horizontalAlignment: string,
        verticalAlignment: string
        maxWidth: string,
        comboDotsColor:string | null,
        comboDotsColorActive:string | null,
        comboLineColor:string | null
    },
    sets: any,
}

type vTimelineComboProps = {
    verticalAlignment: string,
    horizontalAlignment: string,
    comboDotsColor:string | null,
    comboLineColor:string | null
}

const VTimelineCombo = styled.div<vTimelineComboProps>`
&.vTimelineCombo {
    &:before {
        border-right: 3px dashed ${props => props.comboLineColor || 'var(--theme-color-1)'};
    }
    .timelineItem {
        text-align:left;
        }
        .dot {
            background: ${props => props.comboDotsColor || 'var(--theme-color-1)'}; 
        }
        @media (max-width: 768px) {
            margin-right: 0;
            margin-left: auto; 
            width: 450px;
            max-width:100%;
        }
    }
`;


const VTimeline: FC<vTimelineProps> = ({...props}): ReactElement => {

    const observer = new IntersectionObserver(function(entries:any) {
        entries.forEach((entry:any) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible')
            }
        }, {
            threshold: [0.3]
        });
    });

    useEffect(() => {
        var list = document.querySelectorAll('.vTimelineCombo .timelineItem');
        list.forEach((element) => {
            observer.observe(element);
        });
    });

    function setInstance(index: number, setData: any) {
        return <Set key={index} {...setData} editorPlugins={props.editorPlugins} index={index} path={getPath(index)}/>;
    }

    function getPath(index: number) {
        if (!props.path) return null;
        let path = {...props.path};
        path.setIndex = index;
        return path;
    }

    return (
        <VTimelineCombo className={'combo vTimelineCombo'} verticalAlignment={props.settings.verticalAlignment} horizontalAlignment={props.settings.horizontalAlignment}
                        comboDotsColor = {props.settings.comboDotsColor} comboLineColor={props.settings.comboLineColor}>
            {
                props.sets.map((set: any, index: number) => {
                    return (
                        <div className={'timelineItem'} key={index}>
                            {setInstance(index, set)}
                            <div className="dot"></div>
                        </div>
                    );
                })
            }
        </VTimelineCombo>
    );

};
export default VTimeline;
